import React, { useEffect, useState, useMemo, useCallback } from "react";
import * as Text from "@/components/text";
import axios from "axios";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import classNames from "classnames";
import { format } from "date-fns";

import { atom, useAtom, useAtomCallback } from "jotai";

export const calendarAtom = atom(null);
export const dayAtom = atom(format(new Date(), "dd-M"));
export const cityAtom = atom("");

const monthsMap = {
  1: "ene",
  2: "feb",
  3: "mar",
  4: "abr",
  5: "may",
  6: "jun",
  7: "jul",
  8: "ago",
  9: "sep",
  10: "oct",
  11: "nov",
  12: "dic",
};

const citiesMap = {
  "ciudad-de-mexico": "Ciudad de México",
  michoacan: "Michoacán",
  chihuahua: "Chihuahua",
  aguascalientes: "Aguascalientes",
  veracruz: "Veracruz",
};

export default function ScrollingCalendar() {
  const [calendarData, setCalendarData] = useAtom(calendarAtom);
  const [localCalendarData, setLocalCalendarData] = useState([]);
  const [day, setDay] = useAtom(dayAtom);
  const [city, setCity] = useAtom(cityAtom);
  const [sorted, setSorted] = useState(false);

  useEffect(() => {
    // closest calendar date to today
    if (calendarData?.length > 0) {
      const today = format(new Date(), "dd-M");

      calendarData?.forEach((d, i) => {
        if (d.days.includes(today)) {
          setDay(today);
        } else {
          setDay(calendarData[0].days[0]);
        }
      });

      let allDates = [];
      calendarData?.forEach((d, i) => {
        allDates = [...allDates, ...d.days];
        if (!sorted) {
          const copy = [...calendarData];
          copy?.forEach((d, i) => {
            d.days.sort((a, b) => {
              const [dayA, monthA] = a.split("-");
              const [dayB, monthB] = b.split("-");
              const dateA = new Date(2021, monthA - 1, dayA);
              const dateB = new Date(2021, monthB - 1, dayB);
              return dateA - dateB;
            });
          });

          copy?.sort((a, b) => {
            const [dayA, monthA] = a.days[0].split("-");
            const [dayB, monthB] = b.days[0].split("-");
            const dateA = new Date(2021, monthA - 1, dayA);
            const dateB = new Date(2021, monthB - 1, dayB);
            return dateA - dateB;
          });

          setLocalCalendarData(copy);
          setSorted(true);
        }
      });

      // find closest date to today
      const closestDate = allDates.reduce((a, b) => {
        const x = a.split("-");
        const y = b.split("-");
        const aDate = x[1] + x[0];
        const bDate = y[1] + y[0];
        const today = format(new Date(), "dd-M");
        const todayDate = today.split("-");
        const todayDateFormatted = todayDate[1] + todayDate[0];

        return Math.abs(bDate - todayDateFormatted) <
          Math.abs(aDate - todayDateFormatted)
          ? b
          : a;
      });
      setDay(closestDate);
      setCity(calendarData[0].title.toLowerCase());
    }

    return () => {
      setSorted(false);
    };
  }, [calendarData, setCalendarData, setDay]);

  return (
    <div className="">
      <Flicking
        nested={true}
        align="prev"
        viewportTag="div"
        cameraTag="div"
        className="flex "
        circular={true}
      >
        {localCalendarData?.map((d, i) => (
          <div key={i} className="flex grow flex-col">
            <VenueComponent title={d?.title} days={d?.days} />
          </div>
        ))}
      </Flicking>
    </div>
  );
}

function VenueComponent({ title = "", days = [] }) {
  const [day, setDay] = useAtom(dayAtom);
  const [city, setCity] = useAtom(cityAtom);

  return (
    <>
      <div className="relative border-l-2 border-neutral-900">
        <div className="left-0  ml-2">
          <Text.Title className="capitalize " size="md">
            {title.toLowerCase()}
          </Text.Title>
        </div>
        <div className="flex ">
          {days.map((d, i) => (
            <div
              onClick={() => {
                setCity(title.toLowerCase());
                setDay(d);
              }
              }
              key={i}
              className={classNames(
                day === d && city.toLowerCase() == title.toLowerCase() ? "bg-black text-white" : "",
                "flex h-12 w-12 grow cursor-pointer flex-col  items-center justify-center border-b border-r border-neutral-200  align-middle hover:bg-black hover:text-white"
              )}
            >
              <Text.Body className="m-none align-bottom" size="md">
                {d.split("-")[0]}
              </Text.Body>
              <Text.Body className="m-none flex align-top" size="md">
                {monthsMap[d.split("-")[1]]}
              </Text.Body>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
